<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">Bank/Cash Acc. User
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" 
          v-b-tooltip.hover title="Please select USER, before click me"
          @click="lkuBankShow = true" 
          :disabled="!(tblData.username)">Add</b-button>
          <button class="btn btn-primary mr-1" @click="close()"> <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col>
          <b-input-group>
            <b-input-group-prepend><span class="pt-2 pr-2">User Name</span></b-input-group-prepend>
            <b-form-input readonly v-model="tblData.username" placeholder="Select User !"></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuUserShow = true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col>
          <b-form-group label-cols=3 label="Bank/Cash Account">
            <b-row>
              <b-col class="pr-1" cols="4"><b-form-input v-model="tblData.kode"
                  placeholder="Code"></b-form-input></b-col>
              <b-col class="pl-1" cols="8"><b-form-input v-model="tblData.namabank"
                  placeholder="Account Name"></b-form-input></b-col>
            </b-row>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label-cols=3 label="Cash/Bank">
            <b-row>
              <b-col cols="3" class="pl-1">
                <b-form-select v-model="tblData.isbank" :plain="true" :options="dataList.BankOrCashAll"></b-form-select>
              </b-col>
              <b-col cols="9" class="pr-0">
                <b-row>
                  <b-button class="btn btn-success ml-3 mr-1" @click="refresh()"> <i class="fa fa-refresh"></i> Apply
                    Filter</b-button>
                  <b-button class="btn btn-secondary" @click="clearFilter()"> <i class="fa fa-eraser"></i>Clear
                    Filter</b-button>
                </b-row>
              </b-col>
            </b-row>
          </b-form-group>
        </b-col>
      </b-row>
      <b-table class="mb-0" ref="table" outlined responsive hover small style="font-size:smaller;" :items="data"
        :fields="tblFields" :current-page="tblData.page" :per-page="tblData.limit" :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc" :key="tblData.limit" @row-clicked="rowClicked">
        <template v-slot:cell(kodeacc)="data">
          <span v-if="(data.item.isbank == 1)">{{ data.item.kodeacc }}</span>
          <span v-else style="color:green;">{{ data.item.kodeacc }}</span>
        </template>
        <template v-slot:cell(namabank)="data">
          <span v-if="(data.item.isbank == 1)">{{ data.item.namabank }}</span>
          <span v-else style="color:green;">{{ data.item.namabank }}</span>
        </template>
        <template v-slot:cell(matauang)="data">
          <span v-if="(data.item.isbank == 1)">{{ data.item.matauang }}</span>
          <span v-else style="color:green;">{{ data.item.matauang }}</span>
        </template>
        <template v-slot:cell(namabank2)="data">
          <span v-if="(data.item.isbank == 1)">{{ data.item.namabank2 }}</span>
        </template>
        <template v-slot:cell(action)="data">
          <div class="text-center">
            <!-- <a href="javascript:void(0)" @click.stop="edit(data.item)">
              <i class="fa fa-pencil"></i>
            </a> -->
            <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
              <i class="fa fa-trash"></i>
            </a>
          </div>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }}
            to <span v-if="((tblData.page * tblData.limit) > tblData.total)">{{ tblData.total }}</span> <span v-else>{{
              tblData.page * tblData.limit }}</span>
            of {{ tblData.total }} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-row class="ml-2 mt-2">
            <span class="pt-1 pr-2">Limit per page</span>
            <input type="number" style="width:80px;" v-model="tblData.limit" />
          </b-row>
        </b-col>
        <b-col cols="4">
          <b-pagination align="right" :total-rows="tblData.total" :per-page="tblData.limit"
            v-model="tblData.page"></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <b-modal v-model="lkuBankShow" size="lg" :hide-footer="true" title="List of Bank" :centered="true" :lazy="true">
      <lku-bank @click="onSelectLkuCoa" :tahun="tahun" :key="tahun"></lku-bank>
    </b-modal>
    <b-modal v-model="lkuUserShow" size="lg" :hide-footer="true" title="List of Users" :centered="true">
      <lku-user @click="onSelectUser"></lku-user>
    </b-modal>
  </div>
</template>


<script>
import lkuUser from "../lookup/lkuUser.vue";
import lkuBank from "../lookup/lkuBankaccountAll.vue";
import toastr from "mini-toastr";
import bankcashacc from "../../apis/bankcashacc";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import dropdown from "../../data/dropdown";
import crud from "../../apis/crud";
toastr.init();

export default {
  components: { lkuUser, lkuBank },
  mixins: [validationMixin],
  validations: {
    frmdata: {
      namabank: { required },
      kodeacc: { required },
      matauang: { required },
      namabank2: {
        required: (function () {
          if (!(this.frmdata.isbank != '1')) {
            return true;
          } else if (!(this.frmdata.namabank2)) {
            return false;
          } else return true;
        })
      },
      nomorrek: {
        required: (function () {
          if (!(this.frmdata.isbank != '1')) {
            return true;
          } else if (!(this.frmdata.nomorrek)) {
            return false;
          } else return true;
        })
      },
      bankAccName: {
        required: (function () {
          if (!(this.frmdata.isbank != '1')) {
            return true;
          } else if (!(this.frmdata.bankAccName)) {
            return false;
          } else return true;
        })
      },

    },
  },
  data() {
    return {
      showDelConfirm: false,
      lkuUserShow: false,
      horizontal: true,
      showList: true,
      showForm: false,
      showFilter: true,
      lkuBankShow: false,
      lkuCoaCaller: 'debit',
      tahun: (this.$store.state.user.tglaktif || '').substring(0, 4),
      currency: [],
      uanguser: this.$store.state.user.matauang,
      frmdata: { frmmode: 'add', namabank: '', kodeacc: '', glAccount: '', kode: '', matauang: '', aktif: '0', isbank: '1', namabank2: '' },
      tblData: {
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        username: '', full_name: '',
        sortBy: 'namabank',
        sortDesc: false, aktif: '1', isbank: ''
      },
      tblFields: [
        {
          key: "kodeacc",
          label: "GL Account",
          thStyle: "width:100px",
          sortable: true
        },
        {
          key: "namabank",
          thStyle: "width:250px",
          label: "Account Name",
          sortable: true
        },
        {
          key: "matauang",
          thStyle: "width:40px",
          label: "Rp,$,¥",
          sortable: true
        },
        {
          key: "namabank2",
          label: "Nama Bank",
          thStyle: "width:250px",
          sortable: true
        },
        {
          key: "nomorrek",
          label: "Nomor Rekening",
          thStyle: "width:100px",
          sortable: true
        },
        {
          key: "bankAccName",
          label: "Pemilik Rekening",
          thStyle: "width:150px",
          sortable: true
        },
        {
          key: "cabang",
          label: "Cabang",
          thStyle: "width:100px",
          sortable: true
        },
        {
          key: "aktif",
          label: "Active",
          thStyle: "width:40px",
          sortable: true
        },
        {
          key: "action",
          label: "Action",
          thStyle: "width:40px",
          thClass: "text-center",
        }
      ],
      dataList: {
        YesNo: dropdown.YesNo,
        YesNoAll: dropdown.YesNoAll,
        BankOrCash: [{ value: '0', text: 'CASH' }, { value: '1', text: 'BANK' }],
        BankOrCashAll: [{ value: '', text: '-ALL-' }, { value: '0', text: 'CASH' }, { value: '1', text: 'BANK' }],
      }

    };
  },
  computed: {
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
    user() {
      return this.$store.state.user;
    }
  },
  created: async function () {
    this.currency = await bankcashacc.currency();
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    exportxls: async function () {
      this.isLoading = true;
      try {
        this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
        const response = await bankcashacc.exportxls(this.tblData);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message);
        } else {
          toastr.error(JSON.stringify(error));
        }
      }
    },
    data: async function (ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      const list = await bankcashacc.listByUser(this.tblData);
      return list;
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    clearFilter(ctx) {
      this.tblData.kodeacc = '';
      this.tblData.namaacc = '';
      this.tblData.namabank = '';
      this.refresh();
    },
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function () {
      try {
        await crud.update({
          tablename: 'bank-user',
          key: this.model.id,
          data: {
            kode_bank: `${this.model.kode}_${Date.now()}`,
            modified: new Date(),
            isdeleted: 1,
            deleteby: this.user.username
          },
        });
        this.refresh();
      } catch (error) {

      }

    },
    onSelectUser(_selected) {
      this.tblData.username = _selected.username;
      this.tblData.full_name = _selected.full_name;
      this.lkuUserShow = false;
      this.refresh();
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = 'info';
      this.$forceUpdate();
    },
    showLkuCoa(callerObj) {
      this.lkuBankShow = true;
      this.lkuCoaCaller = callerObj;
    },
    async onSelectLkuCoa(_selected) {
      try {
        let findBankUs = await crud.list({
          tablename: 'bank-user',
          page: 1,
          limit: 10000,
          total: 0,
          sortBy: 'kode_bank',
          sortDesc: false,
          customQuery: "kode_bank=" + encodeURIComponent(_selected.kode) + "&username=" + encodeURIComponent(this.tblData.username) + "&isdeleted=0",
        });
        if (findBankUs.length > 0) {
          toastr.info('Bank Already Exists');
        } else {
          await crud.insert({
            tablename: "bank-user",
            data: {
              username: this.tblData.username,
              kode_bank: _selected.kode,
              createby: this.user.username,
            }

          });
          toastr.success('Success,Bank Register');
        }
        this.refresh();
        this.lkuBankShow = false;
      } catch (error) {
        if (error.message) {
          toastr.error(error.message);
        } else {
          toastr.error(JSON.stringify(error));
        }
      }

    },
    closeFrm() {
      this.showForm = false;
      this.showList = true;
    },
    close() {
      router.push("home");
    },

  }
};
</script>
